// wrapper directive for https://tempusdominus.github.io/bootstrap-4/

import { Directive, OnInit, OnDestroy, HostListener, Input, Renderer2, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const DATETIME_PICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatetimePickerDirective),  // tslint:disable-line: no-forward-ref
  multi: true
};

export const DATETIME_PICKER_DEFAULTS: any = {
  get locale() {
    delete this.locale;
    return this.locale = moment.locale();
  },
  date: moment().startOf('day'),
  format: 'l LT',
  buttons: {
    showToday: true,
    showClose: true
  },
  icons: {
    clear: 'fa fa-trash'
  },
  keepInvalid: true,
  extraFormats: [moment.ISO_8601],
  utc: false
};

@Directive({
  selector: 'input[type=text][appDatetime][ngModel]',
  providers: [DATETIME_PICKER_VALUE_ACCESSOR]
})
export class DatetimePickerDirective implements ControlValueAccessor, OnInit, OnDestroy {

  _onChange: (_: any) => void = () => {};
  _onTouched: () => void = () => {};
  @Input('appDatetime') datetimeOptions; // tslint:disable-line: no-input-rename
  selection: JQuery;
  picker;
  model;

  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef
  ) {
    this.selection = $(_elementRef.nativeElement);
  }

  ngOnInit() {
    this.initPicker();
  }

  ngOnDestroy() {
    this.destroyPicker();
  }

  @HostListener('blur', ['$event'])
  onBlur = (event) => {
    this._onTouched();

    try {
      this.picker.hide();
    } catch (err) {
      // datetime picker (tempusdominus-bootstrap-4 v5.0.0-alpha8) has a bug
      // that can causes errors here. supressing the errors for now.
    }

    let date = this.parseDatetime(event.target.value);
    if (!moment(this.model).isSame(date)) {
      this.writeValue(date);
      this.onChange(date);
    }
  }

  onChange(value) {
    let date = null;
    if (value.isValid()) {
      date = this.picker.options().utc ? value.toISOString() : value.format('YYYY-MM-DDTHH:mm:ss');
    }
    if (this._onChange) {
      this._onChange(date);
    }
  }

  writeValue(value: any): void {
    this.model = this.parseDatetime(value);
    this.picker.date(this.model);
    if (!this.model.isValid()) {
      this._renderer.setProperty(this._elementRef.nativeElement, 'value', '');
    }
  }

  registerOnChange(fn: (_) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }

  initPicker() {
    let opts = { ...DATETIME_PICKER_DEFAULTS, ...this.datetimeOptions };
    this.selection.datetimepicker(opts);
    this.picker = this.selection.data('datetimepicker');
  }

  destroyPicker() {
    this.selection.remove();
  }

  parseDatetime(value: any) {
    // let picker handle date parsing
    return !value ? moment(null) : this.picker._parseInputDate(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/datetime-picker.directive.ts